import { api, setToken, clearToken } from './client';

export interface LoginResp {
  token: string;
  user: { id: number; username: string; displayName: string; role: number };
}

export async function login(username: string, password: string): Promise<LoginResp> {
  const data = await api.post<LoginResp>('/user/login', { username, password });
  if (data.token) setToken(data.token);
  return data;
}

export function logout() {
  clearToken();
}

export async function getSelf() {
  return api.get<{ id: number; username: string; displayName: string; role: number; phone?: string }>('/user/self');
}

// Slider captcha — issue returns base64 images + token
export const captchaApi = {
  issueSlider: () =>
    api.post<{
      token: string;
      bg: string;
      piece: string;
      bgWidth: number;
      bgHeight: number;
      pieceSize: number;
      pieceY: number;
      expiresIn: number;
    }>('/captcha/slider/issue', {}),
};

// 发送短信验证码 — captcha params required when REQUIRE_CAPTCHA=1
export async function sendSMSCode(
  phone: string,
  purpose: 'login' | 'register' | 'bind' | 'reset_password',
  captcha?: { token: string; x: number; durationMs: number },
) {
  return api.post('/user/sms/send', {
    phone,
    purpose,
    captchaToken: captcha?.token,
    captchaX: captcha?.x,
    captchaDurationMs: captcha?.durationMs,
  });
}

// 手机号一步注册：手机+验证码+密码。成功后后端自动开通 alpha-lab 订阅
// 并赠 ¥20，返回 JWT，这里落盘 localStorage 完成登录态。
export async function registerWithPhone(data: {
  phone: string;
  code: string;
  password: string;
  displayName?: string;
  inviteCode?: string;
  campaignCode?: string;
}): Promise<LoginResp> {
  const resp = await api.post<LoginResp>('/user/register/phone', data);
  if (resp.token) setToken(resp.token);
  return resp;
}

// Beta 用户名注册：后端生成登录账号 user_<name>，不需要手机号或验证码。
export async function registerBeta(data: {
  name: string;
  password: string;
  group: 'beta';
}): Promise<LoginResp> {
  const resp = await api.post<LoginResp>('/user/register/beta', data);
  if (resp.token) setToken(resp.token);
  return resp;
}

// 忘记密码 - 通过手机验证码重置
export async function forgotPassword(data: { phone: string; code: string; newPassword: string }) {
  return api.post('/user/forgot-password', data);
}

// Beta 用户通过登录账号直接重置密码，不发送短信验证码。
export async function forgotBetaPassword(data: { username: string; newPassword: string }) {
  return api.post('/user/forgot-password', data);
}

// 修改个人信息（包括密码）— 改密码需要传 oldPassword
export async function updateSelf(data: { displayName?: string; email?: string; password?: string; oldPassword?: string }) {
  return api.put('/user/self', data);
}
